import React, { useState, useEffect, useRef, useCallback } from "react";
import { MdMoreVert } from "react-icons/md";
import { IoLogOut } from "react-icons/io5";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";

const MobileBottomBar = ({
  MenuItems,
  NavLink,
  useLocation,
  NotificationLayout,
  handleLogout = () => console.log("Logout"),
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Toggle Menu
  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  return (
    <>
      {/* Bottom Navigation Bar (Mobile) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-secondary shadow-[0_-2px_10px_rgba(0,0,0,0.1)] z-50">
        <div className="flex justify-around items-center p-2">
          {MenuItems.primary.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex gap-1 flex-col items-center justify-center text-center p-2 ${
                  isActive ? "text-primary" : "text-background/50"
                } hover:text-primary transition-colors`
              }
            >
              {item.icon()}
              <span className="text-caption font-nunito">{item.title}</span>
            </NavLink>
          ))}

          {/* More Menu */}
          <div className="relative" ref={menuRef}>
            <button
              onClick={toggleMenu}
              className={`flex gap-1 flex-col items-center justify-center p-2 ${
                location.pathname.startsWith("/more")
                  ? "text-primary"
                  : "text-background/50"
              } hover:text-primary transition-colors`}
            >
              <MdMoreVert className="" />
              <span className="text-caption font-nunito">More</span>
            </button>

            {/* Dropdown Menu */}
            {isMenuOpen && (
              <div className="absolute bottom-full right-0 mb-2 w-48 bg-background rounded-lg shadow-lg py-2 border-2 border-secondary/10">
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 w-full px-4 py-3 text-body2 text-secondary hover:bg-background_2/50 font-ptsans"
                >
                  <IoLogOut className="text-subtitle1" />
                  Logout
                </button>
                {MenuItems.ternary
                  .slice()
                  .reverse()
                  .map((item) =>
                    item.title === "Notifications" ? (
                      <Sheet key={item.path}>
                        <SheetTrigger asChild>
                          <button className="flex items-center gap-2 w-full px-4 py-3 text-body2 text-secondary hover:bg-background_2/50 font-ptsans">
                            {item.icon()}
                            {item.title}
                          </button>
                        </SheetTrigger>
                        <SheetContent
                          className="bg-background_2 w-full !max-w-none lg:w-[520px]"
                          aria-describedby=""
                        >
                          <SheetHeader>
                            <SheetTitle className="font-nunito text-headline4 md:text-headline3 font-bold">
                              Notifications
                            </SheetTitle>
                          </SheetHeader>
                          {NotificationLayout && <NotificationLayout />}
                        </SheetContent>
                      </Sheet>
                    ) : (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        onClick={toggleMenu}
                        className={({ isActive }) =>
                          `flex items-center gap-2 w-full px-4 py-3 text-body2 ${
                            isActive
                              ? "text-ternary/85 font-semibold bg-background_2/50"
                              : "text-secondary"
                          } hover:bg-background_2/50 font-ptsans`
                        }
                      >
                        {item.icon()}
                        {item.title}
                      </NavLink>
                    )
                  )}

                {MenuItems.secondary
                  .slice()
                  .reverse()
                  .map((item) => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      onClick={toggleMenu}
                      className={({ isActive }) =>
                        `flex items-center gap-2 w-full px-4 py-3 text-body2 ${
                          isActive
                            ? "text-ternary/85 font-semibold bg-background_2/50"
                            : "text-secondary"
                        } hover:bg-background_2/50 font-ptsans`
                      }
                    >
                      {item.icon()}
                      {item.title}
                    </NavLink>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileBottomBar;
